export const REGENERATION_INVOICE_USE_CASE_ID = 3;

export const getCommaSeparatedCount = (value) => {
    if (!value || !String(value).trim()) {
        return 0;
    }

    return String(value)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .length;
};

export const getRegenerationInvoicePiTiErrors = (piNo, tiNo, messages) => {
    const piCount = getCommaSeparatedCount(piNo);
    const tiCount = getCommaSeparatedCount(tiNo);

    // Valid when at least one side is a single value; the other may have any count.
    if (piCount > 1 && tiCount > 1) {
        return {
            piError: messages.piTiEitherSingleRequired,
            tiError: messages.piTiEitherSingleRequired,
        };
    }

    return {
        piError: '',
        tiError: '',
    };
};

// Non-regeneration use cases only allow a single PI No and a single TI No.
export const getSinglePiTiErrors = (piNo, tiNo, messages) => ({
    piError: getCommaSeparatedCount(piNo) > 1 ? messages.piTiSingleOnly : '',
    tiError: getCommaSeparatedCount(tiNo) > 1 ? messages.piTiSingleOnly : '',
});

// Resolves the correct PI/TI validation based on the use case.
export const getPiTiErrorsByUseCase = (useCaseId, piNo, tiNo, messages) => {
    if (parseInt(useCaseId, 10) === REGENERATION_INVOICE_USE_CASE_ID) {
        return getRegenerationInvoicePiTiErrors(piNo, tiNo, messages);
    }
    return getSinglePiTiErrors(piNo, tiNo, messages);
};
